<template lang="pug">
include Contact.pug
</template>

<script type="text/javascript">
import _ from "underscore"
import Api from "@/components/services/Api";

export default {
  name: "Contact",
  data() {
    return {
      form: {
        professional: null,
        name: "",
        phone: "",
        email: "",
        message: "",
      },
      opened: false,
    }
  },
  props: ["trainer"],
  created() {
    this.form.professional = this.trainer.id
  },
  methods: {
    isValid() {
      let valid = true

      if (_.isEmpty(this.form.name)) valid = false
      if (_.isEmpty(this.form.email)) valid = false
      if (_.isEmpty(this.form.message)) valid = false

      return valid
    },
    async doSend() {
      // Check if valid
      if (!this.isValid()) {
        return false
      }
      const response = await Api.newContact(this.form.professional, this.form.name, this.form.phone, this.form.email, this.form.message)
      const data = response.data
      // reset data and close
      this.form.name = ""
      this.form.email = ""
      this.form.phone = ""
      this.form.message = ""
      this.opened = false
    }
  }
}
</script>

<style lang="scss" scoped>
@import './../variables';
@import './../variables_colreps';
@import './../variables_mexreps';

@import "Contact";
</style>



// WEBPACK FOOTER //
// src/components/Contact.vue